module.exports = Object.prototype.toString;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/toString.js
 ** module id = 8
 ** module chunks = 0
 **/